import { useState, useEffect } from 'react';
import useDebounce from './UseDebounce';

const useComponentReload = (): number[] => {
  const [size, setSize] = useState<[number, number]>([window.innerWidth, window.innerHeight]);
  const debouncedValue = useDebounce(() => {
    setSize([window.innerWidth, window.innerHeight]);
  }, 300);

  useEffect(() => {
    //console.log('debouncedValue', size);
    window.addEventListener('resize', debouncedValue);
    return () => {
      window.removeEventListener('resize', debouncedValue);
    };
  }, [size]);

  return size;
};

export default useComponentReload;
